module.exports = __webpack_public_path__ + "static/media/3DPPA17.36d12213.jpg";